import { padLeft } from "./pad-left";

export function dateFormat(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${padLeft(month, 2)}-${padLeft(day, 2)}`;
}
